import React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Label, Tooltip } from 'recharts';

interface EmptyPieChartProps {
    title?: string;
    height?: number;
    barChartData: { in_edelivery: number; not_in_edelivery: number };
}

const HalfPieChart: React.FC<EmptyPieChartProps> = ({ barChartData, height = 200 }) => {
    const { in_edelivery = 0, not_in_edelivery = 0 } = barChartData || {};

    const total = in_edelivery + not_in_edelivery;
    const coverRatio = total > 0 ? parseFloat(((in_edelivery / total) * 100).toFixed(2)) : 0;

    const data = [
        { name: 'Covered', value: coverRatio, color: '#FFC107' },
        { name: 'Remaining', value: parseFloat((100 - coverRatio).toFixed(2)), color: '#E0E0E0' },
    ];

    return (
        <>
            <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                Cover Ratio
            </Typography>
            <Stack spacing={1} alignItems="center" sx={{ width: '100%' }}>
                <Box sx={{ width: '100%', height }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            {/* ✅ Added Tooltip with custom formatting */}
                            <Tooltip
                                formatter={(value) => `${value}%`}
                                wrapperStyle={{ zIndex: 1000 }}
                                contentStyle={{ fontSize: 14, padding: '4px 6px', borderRadius: 6 }}
                            />
                            <Pie
                                data={data}
                                dataKey="value"
                                startAngle={180}
                                endAngle={0}
                                innerRadius="60%"
                                outerRadius="90%"
                                cy="75%"
                                isAnimationActive={false}
                            >
                                <Label
                                    value={`${coverRatio}%`}
                                    position="centerBottom"
                                    dy={10}
                                    style={{
                                        fontSize: '24px',
                                        fontWeight: '500',
                                        fill: '#333',
                                    }}
                                />

                                {data.map((entry) => (
                                    <Cell key={entry.name} fill={entry.color} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                </Box>
            </Stack>
        </>
    );
};

export default HalfPieChart;
